<template>
  <CustomModal
    :show="showModal" 
    @closeModal="$emit('close')" 
    size="sm">
    <template #modal-header>
      Billing Period Entry - {{mode}}
    </template>
    <template #modal-body>
      <b-form autocomplete="off">
        <b-form-group
          :invalid-feedback="form.errors.monthId"
          :state="form.states.monthId">
          <label class="required">Applicable Month & Year</label>
          <MonthPickerInput
            input-pre-filled
            :default-month="form.fields.monthId"
            :default-year="form.fields.year"
            @input="onChangeDate"
            :clearable="false" />
        </b-form-group>
      </b-form>
    </template>
    <template #modal-footer>
      <div class="button-footer">
        <SaveButton @click="$emit('save')" :isProcessing="form.isProcessing"/>
        <CloseButton @click="$emit('close')" class="ml-2" :isProcessing="form.isProcessing"/>
      </div>
    </template>
  </CustomModal>
</template>
<script>
import { SaveButton, CloseButton } from '../../components'
import CustomModal from '../../components/CustomModal.vue'
import { MonthPickerInput } from 'vue-month-picker'
export default {
  components: {
    SaveButton, CloseButton,
    CustomModal,
    MonthPickerInput
  },
  props: {
    show: Boolean,
    form: Object,
    mode: String
  },
  methods: {
    onChangeDate(date) {
      const { fields } = this.form
      fields.monthId = date.monthIndex
      fields.year = date.year
    },
  },
  computed: {
    showModal: {
      get: function() {
        return this.show
      },
      set: function(newValue) {
        return newValue
      }
    }
  }
}
</script>

<style lang="scss">
  
</style> 